import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';

@Injectable({
    providedIn: 'root'
})
export class KbMyPriceListService {
    constructor(private http: HttpClient,
        private occService: OccEndpointsService,) { }
    getApi() {
        return this.http.get(this.occService.buildUrl(`myaccount/mypricelist`));
    }
}
